import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.footer');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-footer',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.footer/view.scss */
:host {
  display: block;
}

.footer-container {
  background: linear-gradient(180deg, #0C0A09, #1C1917);
  color: #fff;
  padding: 64px 24px 32px;
}
@media (max-width: 768px) {
  .footer-container {
    padding: 48px 20px 24px;
  }
}

.footer-inner {
  max-width: 1280px;
  margin: 0 auto;
}

.footer-grid {
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 1.2fr;
  gap: 48px;
}
@media (max-width: 1024px) {
  .footer-grid {
    grid-template-columns: 1fr 1fr;
    gap: 40px;
  }
}
@media (max-width: 640px) {
  .footer-grid {
    grid-template-columns: 1fr;
    gap: 32px;
  }
}

.footer-brand {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.footer-logo {
  display: inline-flex;
  text-decoration: none;
}
.footer-logo img {
  height: 24px;
  opacity: 0.9;
  transition: opacity 0.2s ease;
}
.footer-logo:hover img {
  opacity: 1;
}

.footer-slogan {
  font-size: 16px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
  max-width: 240px;
}

.footer-col {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.footer-heading {
  font-size: 16px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.4);
  text-transform: uppercase;
  letter-spacing: 0;
  margin: 0;
}

.footer-links {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.footer-link {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: color 0.2s ease;
  cursor: pointer;
}
.footer-link:hover {
  color: #FE5A33;
}

.footer-contact {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.contact-item {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.6);
  display: flex;
  gap: 8px;
  line-height: 1.5;
}

.contact-label {
  font-weight: 600;
  color: rgba(255, 255, 255, 0.4);
  min-width: 36px;
  flex-shrink: 0;
}

.contact-address {
  margin-top: 4px;
}

.footer-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin: 48px 0 24px;
}
@media (max-width: 768px) {
  .footer-divider {
    margin: 32px 0 20px;
  }
}

.footer-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media (max-width: 640px) {
  .footer-bottom {
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
  }
}

.footer-copyright {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.35);
}

.footer-powered {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.35);
}`],
})
export class ComponentFooterComponent implements OnInit {
    public year: number = new Date().getFullYear();

    constructor(@Inject( Service) public service: Service) {}

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }
}

export default ComponentFooterComponent;